<template>
  <div class="recommendations">
    <div class="content">
      <div class="recommendations__title">Материалы для вас:</div>
      <div class="recommendations__filters">
        <Select
          :taggable="false"
          :push-tags="false"
          class="filter__item"
          v-model="therapeutic_areas"
          :items="therapeutic_areas_list"
          :placeholder="'Терапевтические области'"
          :multiple="true"
          @change="
            onFilterChange('Терапевтические области', therapeutic_areas_YM)
          "
          @optionTriggered="setCurrentFilter"
        />
        <Select
          :taggable="false"
          :push-tags="false"
          class="filter__item"
          v-model="disease"
          :items="disease_list"
          :placeholder="'Заболевание'"
          :multiple="true"
          @change="onFilterChange('Заболевание', disease_YM)"
          @optionTriggered="setCurrentFilter"
        />
      </div>
      <div
        class="filter__current-filter"
        v-if="currentFilter && currentFilter.length"
      >
        <div
          class="filter__current-filter-item"
          v-for="(item, ind) in currentFilter"
          :key="ind"
        >
          <span v-html="item.label"></span>
          <span
            @click="removeFilterItem(item.label, item.value)"
            class="ml-2 filter-item__remove"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2.00012C6.49 2.00012 2 6.49012 2 12.0001C2 17.5101 6.49 22.0001 12 22.0001C17.51 22.0001 22 17.5101 22 12.0001C22 6.49012 17.51 2.00012 12 2.00012ZM15.36 14.3001C15.65 14.5901 15.65 15.0701 15.36 15.3601C15.21 15.5101 15.02 15.5801 14.83 15.5801C14.64 15.5801 14.45 15.5101 14.3 15.3601L12 13.0601L9.7 15.3601C9.55 15.5101 9.36 15.5801 9.17 15.5801C8.98 15.5801 8.79 15.5101 8.64 15.3601C8.35 15.0701 8.35 14.5901 8.64 14.3001L10.94 12.0001L8.64 9.70012C8.35 9.41012 8.35 8.93012 8.64 8.64012C8.93 8.35012 9.41 8.35012 9.7 8.64012L12 10.9401L14.3 8.64012C14.59 8.35012 15.07 8.35012 15.36 8.64012C15.65 8.93012 15.65 9.41012 15.36 9.70012L13.06 12.0001L15.36 14.3001Z"
                fill="currentColor"
              />
            </svg>
          </span>
        </div>
        <div
          class="filter__clear button button_empty-pink button_small"
          @click="clearFilter()"
        >
          Сбросить
          <span class="ml-2">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.5 3.50012L12.5 12.5001"
                stroke="currentColor"
                stroke-linecap="square"
              />
              <path
                d="M12.5 3.50012L3.5 12.5001"
                stroke="currentColor"
                stroke-linecap="square"
              />
            </svg>
          </span>
        </div>
      </div>
      <div class="recommendations__categories">
        <div
          class="recommendations__category"
          :class="{
            recommendations__category_active: currentCategory == item.value,
          }"
          v-for="(item, ind) in categories"
          :key="ind"
          @click="setCategory(item.value)"
        >
          {{ item.label }}
        </div>
      </div>
      <div v-if="!materialsList" class="preloader detail-page__preloader">
        <Preloader class="" />
      </div>
      <div
        v-if="materialsList && !materialsList.length"
        class="recommendations__empty"
      >
        По выбранному фильтру нет материалов
      </div>
      <div
        class="recommendations__list"
        v-if="materialsList && materialsList.length"
      >
        <RecMaterial
          v-for="ind in materialsListLength"
          :item="materialsList[ind - 1]"
          :key="ind"
          :hideFavorites="true"
          @recClick="recClick"
        />
      </div>
      <div
        class="recommendations__load button button_pink"
        v-if="materialsList && materialsList.length > listLength"
        @click="loadMore()"
      >
        Загрузить ещё
        <span class="ml-2">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.5 12.7501L4.5 12.0001H3V12.7501H4.5ZM19.5 12.7501C19.5 16.8923 16.1421 20.2501 12 20.2501L12 21.7501C16.9706 21.7501 21 17.7207 21 12.7501L19.5 12.7501ZM12 20.2501C7.85786 20.2501 4.5 16.8923 4.5 12.7501H3C3 17.7207 7.02944 21.7501 12 21.7501L12 20.2501ZM12 5.25012C16.1421 5.25012 19.5 8.60799 19.5 12.7501L21 12.7501C21 7.77956 16.9706 3.75012 12 3.75012V5.25012ZM7.56864 6.69856C8.8101 5.78779 10.3412 5.25012 12 5.25012V3.75012C10.0114 3.75012 8.17143 4.39596 6.68136 5.48912L7.56864 6.69856Z"
              fill="#B36697"
            />
            <path
              d="M8.08391 1.05776L6.37094 6.61929L11.9325 8.33225"
              stroke="#B36697"
              stroke-width="1.5"
            />
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Select from "@/components/form-elements/Select.vue";
import { mapActions, mapGetters } from "vuex";
import RecMaterial from "@/components/pageComponents/RecMaterial.vue";
import Preloader from "@/components/Preloader.vue";
export default {
  name: "Recommendations",
  data: () => ({
    disease: [],
    therapeutic_areas: [],
    currentFilter: [],
    materialsList: null,
    currentCategory: "all",
    count: 24,
    listLength: 24,
    categories: [
      { label: "Все", value: "all" },
      { label: "Публикации", value: "text" },
      { label: "Подкасты", value: "podcast" },
      { label: "Видеоматериалы", value: "video" },
      { label: "Проекты", value: "project" },
      { label: "Препараты", value: "drug" },
    ],
  }),
  components: {
    Select,
    RecMaterial,
    Preloader,
  },
  computed: {
    ...mapGetters(["user", "NosologysFilter", "DiseaseFilter"]),
    therapeutic_areas_list() {
      return this.NosologysFilter.map((el) => ({
        label: el.title,
        value: el.slug || el.id,
      }));
    },
    disease_list() {
      return this.DiseaseFilter.map((el) => ({
        label: el.title,
        value: el.slug || el.id,
      }));
    },
    materialsListLength() {
      return this.listLength > this.materialsList.length
        ? this.materialsList.length
        : this.listLength;
    },
    therapeutic_areas_YM() {
      let arr = [];
      this.therapeutic_areas.forEach((i) => {
        let find = this.therapeutic_areas_list.find((el) => el.value === i);
        if (find) {
          arr.push(find.label);
        }
      });
      return arr;
    },
    disease_YM() {
      let arr = [];
      this.disease.forEach((i) => {
        let find = this.disease_list.find((el) => el.value === i);
        if (find) {
          arr.push(find.label);
        }
      });
      return arr;
    },
  },
  methods: {
    ...mapActions(["fetchLibraryFilter"]),
    onFilterChange(name, value) {
      if (typeof ym !== "undefined") {
        // ym goal if need
      }
    },
    setCurrentFilter(arg, state) {
      if (state) {
        this.currentFilter = this.currentFilter.concat(arg);
        this.currentFilter = this.currentFilter.filter(
          (obj, index, self) =>
            index === self.findIndex((t) => t.label === obj.label)
        );
      } else {
        this.removeFilterItem(arg.label, arg.value);
      }
    },
    removeFilterItem(label, value) {
      const index = this.currentFilter.findIndex(
        (i) => i.label == label && i.value == value
      );
      const dis_index = this.disease.indexOf(value);
      if (dis_index !== -1) {
        this.disease.splice(dis_index, 1);
      }
      const ter_index = this.therapeutic_areas.indexOf(value);
      if (ter_index !== -1) {
        this.therapeutic_areas.splice(ter_index, 1);
      }
      if (index !== -1) {
        this.currentFilter.splice(index, 1);
      }
    },
    clearFilter() {
      this.disease = [];
      this.therapeutic_areas = [];
      this.currentFilter = [];
    },
    async getSpecialityInfo() {
      return this.$axios({
        url: `/api/auth/speciality-info`,
        method: "GET",
      }).then((res) => {
        this.disease = res.data.disease.map((el) => el.slug);
        this.therapeutic_areas = res.data.nosology.map((el) => el.slug);
        this.currentFilter = this.currentFilter.concat(
          this.disease_list.filter((el) => this.disease.includes(el.value))
        );
        this.currentFilter = this.currentFilter.concat(
          this.therapeutic_areas_list.filter((el) =>
            this.therapeutic_areas.includes(el.value)
          )
        );
      });
    },
    getMaterials() {
      this.materialsList = null;
      this.$axios({
        url: `/api/content/recommendations/`,
        method: "GET",
        params: {
          ct: this.currentCategory,
          disease: this.disease,
          therapeutic_areas: this.therapeutic_areas,
        },
        paramsSerializer: {
          indexes: null,
        },
      })
        .then((res) => {
          this.materialsList = res.data;
          this.listLength = 24;
        })
        .catch(() => {
          this.materialsList = [];
        });
    },
    setCategory(category) {
      if (category == this.currentCategory) return;
      this.currentCategory = category;
    },
    loadMore() {
      this.listLength =
        this.listLength + this.count > this.materialsList.length
          ? this.materialsList.length
          : this.listLength + this.count;
    },
    recClick(item) {
      this.$axios(`/api/analytics/send/`, {
        method: "POST",
        data: {
          brand_name: item.brands.map((el) => el.title).join(", "),
          brand_id: item.brands.map((el) => el.brand_id).join(", "),
          content_id: item.id || "",
          content_name: item.name,
          content_type: item.type,
          nosology_name: item.disease.map((el) => el.title).join(", "),
          content_parameter: "",
          event_type: "click",
          url: this.$root.analyticData.url,
          event_parameter: "",
          page_block: "",
          page_name: "Раздел рекомендаций",
          page_type: "",
          nova_id: this.$root.analyticData.nova_id,
          session_id: this.$root.analyticData.session_id,
          user_id: this.$root.analyticData.user_id,
          browser: this.$root.analyticData.browser,
          device_type: this.$root.analyticData.device,
          dpl_id: this.$route.query.access || "",
          os: this.$root.analyticData.os,
          utm_campaign: this.$route.query.utm_campaign || "",
          utm_content: this.$route.query.utm_content || "",
          utm_medium: this.$route.query.utm_medium || "",
          utm_source: this.$route.query.utm_source || "",
          utm_term: this.$route.query.utm_term || "",
        },
      });
    },
  },
  created() {
    this.getSpecialityInfo().then(() => {});
  },
  watch: {
    currentFilter() {
      this.getMaterials();
    },
    currentCategory() {
      this.getMaterials();
    },
  },
};
</script>

<style lang="scss" scoped>
.recommendations {
  padding-top: 48px;
  &__empty {
    margin-top: 48px;
    text-align: center;
    padding: 16px 0;
    font-size: 18px;
    line-height: 20px;
    font-weight: 500;
  }
  &__title {
    margin-bottom: 24px;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    color: #1f1f1f;
  }
  &__filters {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 32px;
    @media screen and (max-width: 1220px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 16px 32px;
    }
    @media screen and (max-width: 767px) {
      grid-template-columns: repeat(1, 1fr);
      gap: 16px;
    }
  }
  &__categories {
    margin-top: 24px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    @media screen and (max-width: 767px) {
      overflow-x: auto;
      padding-bottom: 24px;
    }
  }

  &__category {
    width: fit-content;
    padding: 4px 8px;
    border: 1px solid #d8dada;
    border-radius: 99px;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #3c4242;
    transition: 0.3s;
    cursor: pointer;
    &_active {
      border-color: #830051;
      color: #830051;
    }
    @media (hover: hover) {
      &:hover {
        background-color: #830051;
        border-color: #830051;
        color: #fff;
      }
    }
  }

  &__list {
    margin-top: 48px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    @media screen and (max-width: 1220px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media screen and (max-width: 767px) {
      grid-template-columns: repeat(1, 1fr);
      gap: 16px;
    }
  }
  &__load {
    margin: 24px auto;
  }
  & .filter {
    &__current-filter-item {
      display: flex;
      align-items: center;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #333333;

      & svg {
        color: #d9dada;
        transition: 0.3s;
      }

      &:hover {
        & svg {
          color: #830051;
        }
      }

      &:last-child {
        margin-right: 0;
      }
    }

    &__current-filter {
      margin-top: 18px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      gap: 12px;
    }
  }

  .filter-item__remove {
    cursor: pointer;
  }
}
</style>